/* Component Dependencies */
var siteSectionNavTemplate = require('templates/siteSectionNav.hbs');
var AriesComponent = require('libs/aries-component');
var $ = require('jquery');
var Constants = require('libs/constants');

AriesComponent.create({
  type: 'siteSectionNav',
  template: {
    'siteSectionNav': siteSectionNavTemplate
  },
  bindEvents: function() {
    var _self = this;
  	var viewport = Constants.GLOBAL;
  	$(window).on("resize load",function() {
  		var windowWidth = $(window).width();
  		if (windowWidth > viewport.MOBILE_VIEWPORT) {
        if(_self.$el.find('.l-accordion-content').hasClass('l-display-none')){
        _self.$el.find('.l-accordion-content').removeClass('l-display-none').addClass('l-display-block');
        _self.$el.find('.l-accordion-content').css({"display":"block"});
        }
  		}else if(windowWidth <= viewport.MOBILE_VIEWPORT){
        if(_self.$el.find('.l-accordion-content').hasClass('l-display-block')){
        _self.$el.find('.l-accordion-content').removeClass('l-display-block').addClass('l-display-none');
        _self.$el.find('.l-accordion-content').css({"display":"none"});
        }
      }
  	});
  }
});
